import { IconLock as TablerIconLock } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconLock = /*#__PURE__*/ createOutlineIcon(TablerIconLock, 'IconLock');
